import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { FormGroup, FormArray, FormBuilder, AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SectoralMeeting } from 'app/models/sectoral-meeting.model';
import { RegistrationTypeEnum } from 'app/models/lookup-enums.model';
import { ConventionRegistrationSectoralMeeting } from 'app/models/convention-registration-sectoral-meeting.model';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { ConventionRegistrationService } from 'app/convention-registration/convention-registration.service';
import { BaseComponent, ProgressBarService } from '@mrm/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'sectoral-meeting',
  templateUrl: './sectoral-meeting.component.html',
  styleUrls: ['./sectoral-meeting.component.scss']
})
export class SectoralMeetingComponent extends BaseComponent implements OnInit {
  @Input() id: string;
  @Input() readOnly: boolean = false;
  @Input() regType: RegistrationTypeEnum;
  @Input() conventionRegistrationSectoralMeetings: ConventionRegistrationSectoralMeeting[];
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  sectoralMeetingForm: FormGroup;

  sectoralMeetingDataSource: MatTableDataSource<AbstractControl>;
  displayedColumns = ['selectItems', 'name', 'startDate', 'room'];

  constructor(
    private __progressBarService: ProgressBarService,
    private __toastr: ToastrService,
    private __translateService: TranslateService,
    private __router: Router,
    private _formBuilder: FormBuilder,
    private _activeModal: NgbActiveModal,
    private _conventionRegistrationService: ConventionRegistrationService
  ) {
    super(__progressBarService, __toastr, __translateService, __router);
  }

  get sectoralMeetingFormArray(): FormArray {
    return this.sectoralMeetingForm.get('conventionRegistrationSectoralMeetings') as FormArray;
  }

  get canSubmit(): boolean {
    return !this.readOnly && this.sectoralMeetingFormArray.controls.some(x => x.value.selected == true);
  }

  ngOnInit() {
    this.sectoralMeetingForm = SectoralMeeting.getLookupForm();

    this._loadData();
  }

  onCancel() {
    this._activeModal.dismiss();
  }

  onSubmit() {
    const sectoralMeetings: any = this.sectoralMeetingFormArray.getRawValue();
    this._activeModal.close(sectoralMeetings.filter((x: ConventionRegistrationSectoralMeeting) => x.selected));
  }

  private _loadData() {
    this._progressBarService.start();

    this._conventionRegistrationService.getSectoralMeetings(this.regType, this.id)
      .subscribe(this._onLoadDataSuccess.bind(this), this.displayError.bind(this));
  }

  private _onLoadDataSuccess(sectoralMeetings: SectoralMeeting[]) {
    let sectoralMeetingFormArray: FormArray = <FormArray>this.sectoralMeetingForm.get('conventionRegistrationSectoralMeetings');
    sectoralMeetingFormArray = this._formBuilder.array([]);

    sectoralMeetings.forEach(x => {
      const form = ConventionRegistrationSectoralMeeting.getForm(this.readOnly);
      const sectoralMeeting = (this.conventionRegistrationSectoralMeetings && this.conventionRegistrationSectoralMeetings != null) ?
        this.conventionRegistrationSectoralMeetings.find(ex => x.sectoralMeetingDBID == ex.sectoralMeetingDBID) : undefined;

      ConventionRegistrationSectoralMeeting.overrideDefaultForm(form, this.readOnly);

      form.patchValue({
        conventionRegistrationSectoralMeetingDBID: 0,
        conventionRegistrationDBID: 0,
        sectoralMeetingDBID: x.sectoralMeetingDBID,
        createdDT: new Date(),
        createdBy: null,
        modifiedDT: new Date(),
        modifiedBy: null,
        rowVersion: 0,
        name: this.getTwoLetterCulture() == 'fr' ? x.frenchName : x.englishName,
        startDate: x.startDate,
        startTime: x.startTime,
        room: x.room,
        selected: sectoralMeeting != undefined
      });

      sectoralMeetingFormArray.push(form);
    });

    this.sectoralMeetingForm.controls['conventionRegistrationSectoralMeetings'] = this._formBuilder.array(sectoralMeetingFormArray.controls);

    this._reloadDataSource();
    this._progressBarService.stop();
  }

  private _reloadDataSource() {
    this.sectoralMeetingDataSource = new MatTableDataSource(Object.assign([], this.sectoralMeetingFormArray.controls));
    this.sectoralMeetingDataSource.sort = this.sort;
    this.sectoralMeetingDataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'name': return item.value.name == null ? '' : item.value.name;
        case 'startDate': return item.value.startDate == null ? '' : item.value.startDate;
        case 'room': return item.value.room == null ? '' : item.value.room;
        default: return item[property];
      }
    };
  }
}
